import
{
    FC
} from "react";

import TypeAhead from "../TypeAhead/TypeAheadString";

import
{
    Customer,
    PaginatedResult,
    treeContains,
    User
} from "@ews/react-data";

import
{
    getCustomerDisplayName,
    useCustomer,
    useTypeAheadCustomerList
} from "../ReactData/customer";

import
{
    useMyProfile
} from "../Login/LoginProvider";
import { TypeaheadProps } from "../TypeAhead/types";
import { globalDebounceTime, Locale } from "../../setup/locale";

type LabelledCustomer = Customer & {
    label: string;
};

function getOwnCustomerDisplayName(me: User)
{
    return getCustomerDisplayName({ customerNumber: me.customerNumber, name: me.customerName } as Customer);
}

const CustomerTypeAhead: FC<{
    disabled?: boolean;
    label?: Locale;
    currentId?: string;
    allowEmpty?: boolean;
    skipTrees?: string[],
    onChange: (id: string | null) => void;
    id?: string;
}> = ({
    label = "COM_FACPMANAGEMENT_FACP_MANAGER_CUSTOMER",
    currentId = "",
    allowEmpty = false,
    disabled,
    skipTrees = [],
    onChange,
    id
}) =>
    {
        const typeAhead = useTypeAheadCustomerList();
        let customer = useCustomer(currentId);
        customer = currentId === customer.id ? customer : {} as Customer;

        const me = useMyProfile();

        const { customerId, customerName, customerNumber } = me;

        const empty = "---";
        const placeHolder = customerId ? getCustomerDisplayName({ name: customerName, customerNumber } as Customer) : empty;
        const placeHolderCurrent = currentId ? placeHolder : empty;

        return <TypeAhead
            id={id}
            text={label as Locale}
            disabled={disabled}
            debounce={globalDebounceTime}
            value={customer.id ?
                getCustomerDisplayName(customer) : placeHolderCurrent
            }
            onFilter={async (value) => new Promise<TypeaheadProps["list"]>(async resolve =>
            {
                if (disabled) return;

                const search = await typeAhead({ pageSize: 10, name: value, customerNumber: value, searchOperator: "OR", sortCriteria: "name" });
                const items: Customer[] = [];

                if (customerId) {
                    if (customerNumber?.toString().startsWith(value) || customerName?.toUpperCase().includes(value.toUpperCase())) {
                        items.unshift({
                            name: placeHolder,
                            id: customerId,
                            tree: ""
                        } as Customer);
                    }
                };

                if (allowEmpty || !customerId) {
                    items.unshift({
                        name: "---",
                        tree: ""
                    } as Customer);
                }

                resolve([...items, ...search
                    .results]
                    .filter((c) =>
                    {
                        return !skipTrees?.some((tree) => treeContains(tree, c.tree!));
                    })
                    .map((data) =>
                    {
                        (data as LabelledCustomer).label = getCustomerDisplayName(data);
                        return { key: "label", data, preventAutoSelect: !Boolean(data.id) };
                    })
                );
            })}
            onChange={(data) =>
            {
                if (disabled) return;
                const id = data.id;
                onChange(id || null);
            }}
        />;

    };

export default CustomerTypeAhead;
